import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
  OnChanges,
  OnInit,
  DoCheck,
} from '@angular/core'
import { asapScheduler, BehaviorSubject, interval, Observable, of } from 'rxjs'
import { delayWhen, observeOn, switchMap } from 'rxjs/operators'
import { ICON_TYPE, BreakpointService } from '@spartacus/storefront'
import { FacetList } from './facet.model'
import { FacetService } from './services/facet.service'
import { Router, ActivatedRoute } from '@angular/router'
import { ProductListComponentService } from '../list/product-list-component.service'
import { PlpService } from '../plp.service'

@Component({
  standalone: false,

  selector: 'cx-product-facet-navigation',
  templateUrl: './product-facet-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductFacetNavigationComponent implements OnInit, DoCheck {
  iconTypes = ICON_TYPE

  /**
   * We delay the removal of DOM so that animations can finish playing before the
   * DOM is removed. Removing the DOM, as hidding is not enough to stop elements
   * to be focused.
   */
  protected CLOSE_DELAY = 300
  facetList$: Observable<FacetList> = this.facetService.facetList$
  /**
   * Used to open the facet navigation in a dialog. The usage of the dialog depends
   * on the availability of the trigger element, which is driven by CSS.
   *
   * The reference is also used to refocus the trigger after the dialog is closed.
   */
  @ViewChild('trigger') trigger: ElementRef<HTMLElement>

  protected open$ = new BehaviorSubject(false)

  /**
   * Emits the open state that indicates whether the facet list should be rendered.
   * This is either done instantly, or after the user triggers this by using the trigger
   * button. This driven by the visiibility of the trigger, so that the CSS drives
   * the behaviour. This can differ per breakpoint.
   *
   * There's a configurable delay for the closed state, so that the DOM is not removed
   * before some CSS animations are done.
   */
  isOpen$: Observable<boolean> = this.breakpointService.breakpoint$.pipe(
    // deffer emitting a new value to the next micro-task to ensure that the `hasTrigger`
    // method represents the actual UI state.
    observeOn(asapScheduler),
    switchMap(() => (this.hasTrigger ? this.open$ : of(true))),
    delayWhen((launched) => interval(launched ? 0 : this.CLOSE_DELAY))
  )

  /**
   * Emits the active state that indicates whether the facet list is activated. Activation
   * is related to the css, so that a animation or transition can visualize opening/closing
   * the list (i.e. dialog).
   */
  isActive$ = this.open$.pipe(
    // deffer emitting a new value to the next micro-task to ensure the active class is
    //  applied after the DOM is created
    observeOn(asapScheduler)
  )
  clearUrl: string
  url = ''
  sortCode: any
  params: any
  facetList: any

  constructor(
    protected breakpointService: BreakpointService,
    public facetService: FacetService,
    public router: Router,
    public routes: ActivatedRoute,
    public productListComponentService: ProductListComponentService,
    private plpService: PlpService
  ) {}

  launch() {
    this.open$.next(true)
  }

  close() {
    this.open$.next(false)
    this.trigger.nativeElement.focus()
  }

  /**
   * Indicates that the facet navigation should be open explicitely by a trigger.
   * This is fully controlled by CSS, where the trigger button can be hidden
   * (display:none) for certain screen sizes
   */
  get hasTrigger() {
    return this.trigger.nativeElement.offsetParent !== null
  }
  ngOnInit() {
    this.productListComponentService.getSortCode.subscribe((sortCode) => {
      this.sortCode = sortCode
    })

    this.routes.params.subscribe((params) => {
      this.params = params
    })

    this.facetList$.subscribe((response) => {
      this.facetList = response;
    })
  }
  clearAll() {
    if(this.facetList.activeFacets.length > 0) {
      this.productListComponentService.pageChange(50)
      this.productListComponentService.setPagetoDefault(50)
      this.productListComponentService.retainSortCode()
      if(this.params?.categoryCode){
        this.plpService.setCategoryBreadCrumbs(this.params.categoryCode)
      }
      
      if (this.productListComponentService.retainSortCode()) {
        this.router.navigateByUrl(
          this.url +
            '?sortCode=' +
            this.productListComponentService.retainSortCode()
        )
        this.url = ''
      } else {
        this.router.navigateByUrl(this.url)
        this.url = ''
      }
    }
  }
  ngDoCheck() {}
  setRoutes(event) {
    this.url = event
  }
}
